// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2SJiS","dragIcon":"SortableItem_dragIcon__2XuoR","disabled":"SortableItem_disabled__1mdqn"};